import {Sidebar} from "primereact/sidebar";
import React, {RefObject, useContext, useEffect, useRef, useState} from "react";
import ProfiliCaricoContext from "../../Context/ProfiliCaricoContext";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faUser, faRotate} from '@fortawesome/free-solid-svg-icons'
import {Button} from "primereact/button";

type Props = {
    children: JSX.Element,
    refreshAction: () => void,
    container?: RefObject<HTMLDivElement>,
    enableAutoOpen?: boolean
}

const CustomSidebar = (props: Props) => {
    let context = useContext(ProfiliCaricoContext);
    let [mouseIsClose, setMouseIsClose] = useState<boolean>(false);
    let openTimer = useRef<any>(null);

    useEffect(() => {
        if(props.enableAutoOpen ?? false) {
            const moveCallback = function (this: HTMLDivElement, ev: HTMLElementEventMap["mousemove"]) {
                if (!context.sidebarIsOpen) {
                    ev.stopPropagation();
                    const width = this.offsetWidth;
                    const position = ev.offsetX;
                    let perc = position / width;
                    if (perc > 0.95) {
                        setMouseIsClose(true);
                    } else {
                        setMouseIsClose(false);
                    }
                }
            };

            const outCallback = function (this: HTMLDivElement, ev: HTMLElementEventMap["mouseout"]) {
                setMouseIsClose(false);
            }
            props.container?.current?.addEventListener("mousemove", moveCallback);
            props.container?.current?.addEventListener("mouseout", outCallback);

            return () => {
                props.container?.current?.removeEventListener("mousemove", moveCallback);
                props.container?.current?.removeEventListener("mouseout", outCallback);
            };
        }
    }, [context.setSidebarIsOpen, context.sidebarIsOpen, props.container, props.enableAutoOpen]);

    useEffect(() => {
        if(props.enableAutoOpen ?? false) {
            if (mouseIsClose && openTimer.current === null) {
                openTimer.current = setTimeout(() => {
                    context.setSidebarIsOpen!(true);
                    openTimer.current = null;
                }, 400);
            } else {
                if (openTimer.current !== null) {
                    clearTimeout(openTimer.current);
                    openTimer.current = null;
                }
            }
        }
    }, [mouseIsClose, context.setSidebarIsOpen, props.enableAutoOpen])

    const customIcons = (
        <React.Fragment>
            <h3 id="username"><FontAwesomeIcon icon={faUser} className="user-icon" /> {context.username}</h3>
            <button className="p-sidebar-icon p-link mr-1" onClick={props.refreshAction} title="Aggiorna Dati" >
                <FontAwesomeIcon icon={faRotate} />
            </button>
        </React.Fragment>
    );

    return ( <Sidebar visible={context.sidebarIsOpen} position="right" style={{width: 'auto', maxWidth: '100vw'}} onHide={() => {context.setSidebarIsOpen!(false);}} icons={customIcons} id="custom-sidebar">
        <div className="flex flex-column align-items-end justify-content-center h-full">
            <div id="custom-content">
                {props.children}
            </div>
            <div id="sidebar-footer">
                <Button onClick={context.logoutAction} icon="pi pi-sign-out" iconPos="right" label="Logout" className="p-button-outlined p-button-danger" />
            </div>
        </div>
    </Sidebar>);
}

export default CustomSidebar;